import { Button, Divider, Form, Image, Input } from "antd";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Otp from "../../Modal/Otp";
import { verifyNote } from "../../utils";
import Expire from "../../Common/Expires";
import MarkdownRenderer from "../../Common/FormatContent";

const History = () => {
  const [ui, setUI] = useState("");
  const { token } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState("");

  useEffect(() => {
    if (token) {
      verifyMe(token);
    }
  }, []);

  useEffect(() => {
    document.title = "Note - Mon AI";
  }, []);  

  const verifyMe = async (token) => {
    const res = await verifyNote(`/v1/shared-notes/${token}`);

    if (res.status === 200) {
      setUI("otp");
    } else {
      setUI("expire");
    }
  };

  return (
    <>
      {ui === "expire" && <Expire />}
      {ui === "otp" && (
        <Otp
          onSetUi={(value, content) => {
            setUI(value);
            setContent(content);
          }}
          token={token}
        />
      )}
      {ui === "content" && (
        <>
          <div className="w-full flex justify-center items-center">
            <div className="w-full max-w-[360px] border border-[#f0f0f0]">
              <MarkdownRenderer markdown={content}></MarkdownRenderer>
              {/* <div className="fixed top-0 w-full max-w-[360px] z-10 bg-white border-b border-[#EFEEF0] text-center">
            <h1 className="text-base font-medium my-4">Emma, 32F</h1>
          </div>
          <div className="flex flex-col gap-6 px-4 pt-[70px] pb-[50px]">
            <div className="relative">
              <h1 className="text-[20px] font-bold mb-4">History</h1>
              <p>3 day history of dysuria with associated fevers and chills.</p>
              <p>Associated suprapubic pain radiating to left flank.</p>
              <p>
                Pain has worsened despite trying simple analgesics and
                increasing fluid intake.
              </p>
              <p>Denies any new sexual contacts. </p>
              <p>
                No regular medications or significant past medical history of
                note.
              </p>
            </div>
            <div className="relative">
              <h1 className="text-[20px] font-bold mb-4">Examination</h1>
              <p className="mb-4">
                HR 110, SpO2 99% on RA, BP 100/80mmHg, T 38.2C
              </p>
              <p className="mb-4">Appears uncomfortable</p>
              <p>Abodmen is soft with suprapubic guarding and tenderness</p>
              <p>Left flank tenderness</p>
            </div>
            <div className="relative">
              <h1 className="text-[20px] font-bold mb-4">Investigations</h1>
              <p className="w-full max-w-[215px]">
                Urinalysis: RBC ++, WBC +, NIT + Urine MCS ordered
              </p>
            </div>
            <div className="relative">
              <h1 className="text-[20px] font-bold mb-4">Impression</h1>
              <ul>
                <li>Cystitis (UTI)</li>
                <li>Pyelonephritis</li>
              </ul>
            </div>
            <div className="relative">
              <h1 className="text-[20px] font-bold mb-4">Plan</h1>
              <ul>
                <li>Commenced trimethoprim 300mg nocte for 3 nights</li>
                <li>Review results of Urine MCS</li>
                <li>Encourage fluid intake</li>
                <li>Analgesia as required</li>
                <li>Medical certificate provided for work</li>
                <li>Represent if worsening or further concerns</li>
              </ul>
            </div>
            <Divider className="my-0" />
            <div className="relative">
              <p className="text-[12px] font-medium">
                Reminder set on 15/07/2024, 18:30
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <span className="bg-[#EFEEF0] text-[#827D89] text-[12px] font-medium py-[6px] px-[12px] rounded-full">
                Important
              </span>
              <span className="bg-[#EFEEF0] text-[#827D89] text-[12px] font-medium py-[6px] px-[12px] rounded-full">
                Follow-up
              </span>
            </div>

          </div> */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default History;
